module.exports = __webpack_public_path__ + "img/purple-booth-table-6.3ebbad04.png";